import {Component, computed, input, model, signal} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe} from '@jsverse/transloco';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-model-field-text',
  imports: [CommonModule, FormsModule, InputTextModule, TranslocoPipe, DirectusTooltipComponent],
  templateUrl: './model-field-text.component.html',
  styleUrl: './model-field-text.component.scss',
})
export class ModelFieldTextComponent {
  id = input.required<string>();
  label = input<string>('');
  tooltipKey = input<string>('');
  placeholder = input<string>('');
  isReadOnly = input<boolean>(false);
  smallLabel = input<boolean>(false);
  isRequired = input<boolean>(false);

  value = model<string | null>(null);

  protected readonly isTouched = signal<boolean>(false);

  readonly isInvalid = computed(() => {
    if (!this.isRequired() || !this.isTouched()) return false;
    const value = this.value();
    return value === null || value === undefined || value.trim() === '';
  });

  protected markAsTouched(): void {
    this.isTouched.set(true);
  }
}
